import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { Angulartics2Module } from 'angulartics2';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { FeatureFlagsModule } from '../core/feature-flags/feature-flags.module';
import { ContactSalesModalService } from './contact-sales-modal/contact-sales-modal-service';
import { ContactSalesModalComponent } from './contact-sales-modal/contact-sales-modal.component';

import { ContactSalesRoutingModule } from './contact-sales-routing.module';
import { ContactSalesComponent } from './contact-sales/contact-sales.component';

@NgModule({
  declarations: [ContactSalesComponent, ContactSalesModalComponent],
  imports: [
    CommonModule,
    ContactSalesRoutingModule,
    ReactiveFormsModule,
    Angulartics2Module,
    NgbModalModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    FeatureFlagsModule,
  ],
  providers: [ContactSalesModalService],
})
export class ContactSalesModule {}
